export const QUERY_LOC_FROM_AMF_ID = '4';

export const DEPLOYMENT_TUNISIA = 'tunisiamc';
export const DEPLOYMENT_TOROGOZ = 'torogoz';
export const DEPLOYMENT_ANDROMEDA = 'andromeda';
export const DEPLOYMENT_ENDEAVOR = 'endeavor';

export const CASE_OPT_WITH_LOCATION = '5';
